export default __webpack_public_path__ + "images/assets/daf77b39b9c4d1af9052e3a88314b958.svg";